import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

function LandingPage() {
  return (
    <Flex flexDirection="column" minHeight="100vh" overflowX={"hidden"}>
      <Box flex={1}>
        <Outlet />
      </Box>
    </Flex>
  );
}

export default LandingPage;
